import OutboundPendingAllocationMonitorRequests from '../../server/outboundPendingAllocationMonitor';
import { addLoading, removeLoading } from './loading';

export const getDataGrid = (tableParams = {}) => async (dispatch) => {
  dispatch(addLoading());
  try {
    const pendingCut = await OutboundPendingAllocationMonitorRequests.getDataGrid(tableParams);
    return pendingCut;
  } finally {
    dispatch(removeLoading());
  }
};

// Com a lista paginada, o "Marcar Todos" nao enxerga mais a base inteira pela
// grid: os ids que casam com o filtro atual vem do servidor.
export const getDataGridIds = (tableParams = {}) => async (dispatch) => {
  dispatch(addLoading());
  try {
    const result = await OutboundPendingAllocationMonitorRequests.getDataGridIds(tableParams);
    return result;
  } finally {
    dispatch(removeLoading());
  }
};

export const allocateProducts = (outboundOrderId, outboundProductId, isSimulation) => async (dispatch) => {
  dispatch(addLoading());
  try {
    const result = await OutboundPendingAllocationMonitorRequests.allocateProducts(
      outboundOrderId,
      outboundProductId,
      isSimulation,
    );
    return result;
  } finally {
    dispatch(removeLoading());
  }
};

export const allocateBulkProducts = (outboundProductIds) => async (dispatch) => {
  dispatch(addLoading());
  try {
    const result = await OutboundPendingAllocationMonitorRequests.allocateBulkProducts(outboundProductIds);
    return result;
  } finally {
    dispatch(removeLoading());
  }
};
